<template lang="pug">
  v-container(grid-list-md fluid style="padding-top: 0px; overflow:hidden;")
    v-layout.text-xs-center(row wrap)
      v-flex(xs12)
        v-chip
          v-icon(@click="weekIncrement(-1)").left keyboard_arrow_left
          | {{ weekLabel }}
          v-icon(@click="weekIncrement(1)").right keyboard_arrow_right
    v-layout(row wrap)
      v-flex(lg3 sm6 xs12)
        material-stats-card(
          color="info"
          icon="assignment_turned_in"
          title="Efetivados"
          :value="paidCount | number"
          sub-icon="info"
          sub-text="Contratos pagos")
      v-flex(lg3 sm6 xs12)
          material-stats-card(
            color="lime"
            icon="attach_money"
            title="Total"
            :value="paidTotal | money"
            sub-icon="info"
            sub-text="Total em reais (R$)")
      v-flex(lg3 sm6 xs12)
          material-stats-card(
            color="orange"
            icon="people"
            title="Clientes"
            :value="customerNewstatusCount | number"
            sub-icon="info"
            sub-text="Clientes novos")
      v-flex(lg3 sm6 xs12)
          material-stats-card(
            color="purple"
            icon="contact_phone"
            title="Atendimentos"
            :value="callCount | number"
            sub-icon="info"
            sub-text="Contatos realizados")
    v-layout(row wrap v-if="['manager', 'supervisor'].includes(profile)")
      v-flex(xs12)
        material-card(color="amber" title="Atendentes" :height='340')
          apex-charts(v-if='ready' type="bar" :height='295' class="dashchart" :options="chartUsersOptions" :series="chartUsersSeries")
    v-layout(row wrap)
      v-flex(sm6 xs12)
        v-layout(row wrap)
          v-flex(xs12)
            material-card(color="amber" title="Status" :height='340')
              apex-charts(v-if='ready' type="donut" :height='295' class="dashchart" :options="chartStatusOptions" :series="chartStatusSeries")
          v-flex(xs12)
            material-card(color="amber" title="Semana" :height='340')
              apex-charts(v-if='ready' type="bar" :height='295' class="dashchart" :options="chartWeekOptions" :series="chartWeekSeries")
      v-flex(sm6 xs12)
        material-card(color="amber" title="Atendimentos" :height='758')
          div(style="height: 680px;overflow-y: auto;padding-right: 10px;")
            v-timeline(dense='')
              v-slide-x-reverse-transition(group='' hide-on-leave='')
                v-timeline-item(v-for='item in calls' :key='item.iuid' small='' fill-dot='')
                  v-alert(:value='true' :color="item.contractStatus == 'pago' ? 'green' : item.contractStatus == 'proposta' ? 'blue' : item.contractStatus == 'reprovado' ? 'red' : 'purple'" :icon='item.icon')
                    .white--text
                      span.font-weight-light {{ item.status ? item.status.name : '' }}
                      .right
                        v-icon(size="15" color="white") schedule
                        span.font-weight-light  {{ item.createdAt | formatDateTimeAgo}}
                    blockquote
                      span.font-weight-bold {{ item.user.name }}
                      span.font-italic  - " {{ item.description }} "
                      .font-weight-regular {{ item.customer.name }}&nbsp;
                        v-icon(@click="goToCustomer(item.customer.id)" color="white" size="17") visibility
                    .font-weight-bold(v-if="item.contractStatus && item.contractStatus !== ''") {{item.contractStatus == 'pago' ? 'Contrato Pago' : item.contractStatus == 'proposta' ? 'Proposta' : item.contractStatus == 'reprovado' ? 'Reprovado' : ''}}
                      .right(v-if="item.contractValuePaid && item.contractValuePaid !== '0,00'") R$ {{ item.contractValuePaid }}
                      .right(v-else-if="item.contractValue && item.contractValue !== '0,00'") (R$ {{ item.contractValue }})
</template>

<script>

import { setTimeout } from 'timers'
import { mapGetters } from 'vuex'
import { db } from '@/store/firebase'
import firestoreUtils from '@/utils/firestore'
import moment from 'moment'

export default {
  components: {
    ApexCharts: () => import('vue-apexcharts')
  },

  data() {
    return {
      ready: false,
      calls: [],
      weekDateRef: moment(),
      dashboards: [],
      customerCount: null,
      customerNewstatusCount: null,
      callCount: null,
      paidCount: null,
      paidTotal: null,
      statusCount: {},
      chartUsersSeries: [],
      chartUsersOptions: {
        colors: [
          '#008FFB', '#00E396', '#FEB019', '#FF4560',
          '#775DD0', '#33B2DF', '#546E7A', '#D4526E',
          '#13D8AA', '#A5978B'
        ],
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        tooltip: {
          shared: true,
          followCursor: true,
          intersect: false
        },
        dataLabels: {
          enabled: true,
          position: 'top' // top, center, bottom
        },
        xaxis: {
          categories: [],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        }
      },
      chartWeekSeries: [],
      chartWeekOptions: {
        colors: [
          '#008FFB', '#00E396', '#FEB019', '#FF4560',
          '#775DD0', '#33B2DF', '#546E7A', '#D4526E',
          '#13D8AA', '#A5978B'
        ],
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        tooltip: {
          shared: true,
          followCursor: true,
          intersect: false
        },
        xaxis: {
          categories: []
        }
      },
      chartStatusOptions: {
        colors: [
          '#008FFB', '#00E396', '#FEB019', '#FF4560',
          '#775DD0', '#33B2DF', '#546E7A', '#D4526E',
          '#13D8AA', '#A5978B'
        ],
        labels: [],
        legend: {
          position: 'bottom'
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  showAlways: true,
                  show: true
                }
              }
            }
          }
        }
      },
      chartStatusSeries: []
    }
  },

  computed: {
    ...mapGetters(['user', 'profile']),
    weekLabel() {
      // let s = `Semana ${this.weekDateRef.format('WW/YYYY')}`
      let s = `${this.weekDateRef.clone().startOf('week').format('DD/MMMM')} - ${this.weekDateRef.clone().endOf('week').format('DD/MMMM')}`
      if (this.weekDateRef.format('YYYYww') === this.$moment().format('YYYYww')) s += ' (Vigente)'
      // s += ' Semana ' + this.weekDateRef.format('YYYYMMDDww') + ' / ' + this.$moment().format('YYYYMMDDww')
      return s
    }
  },

  created() {
    this.weekDateRef = this.$moment()
  },

  mounted() {
    this.$Progress.start()
    this.loadCalls()
    this.loadDashboard()
    setTimeout(() => {
      this.ready = true
      this.$Progress.finish()
    }, 50)
  },

  methods: {
    weekIncrement(value) {
      this.weekDateRef.add(value, 'weeks')
      this.loadDashboard()
    },
    updateDashboard() {
      let customerCount = 0
      let callCount = 0
      let paidCount = 0
      let paidTotal = 0
      let statusCount = {}
      let statusSeries = []
      let statusCategories = []
      let weekSeries = []
      let weekCategories = []
      let weekDayKeys = {}
      for (let dashboard of this.dashboards) {
        if (dashboard.customerCount) customerCount += dashboard.customerCount
        if (dashboard.callCount) callCount += dashboard.callCount
        if (dashboard.contract && dashboard.contract.paidCount) paidCount += dashboard.contract.paidCount
        if (dashboard.contract && dashboard.contract.paidTotal) paidTotal += dashboard.contract.paidTotal

        // status
        if (dashboard.status) {
          const entries = Object.entries(dashboard.status).filter(arr => arr[1].count >= 0)
          for (let status of entries) {
            const statusId = status[0]
            const statusName = status[1].name
            const count = status[1].count
            if (!statusCount[statusName]) statusCount[statusName] = { count: 0, attendants: {}, days: {} }
            const statusObj = statusCount[statusName]

            // count
            statusObj.count += count
            // attendant
            statusObj.attendants[dashboard.attendant.name] = count
            // Days count
            if (dashboard.days) {
              for (let keyDay of Object.keys(dashboard.days)) {
                weekDayKeys[keyDay] = true
                const dayObj = dashboard.days[keyDay]
                if (dayObj && dayObj.status && dayObj.status[statusId]) {
                  statusObj.days[keyDay] = (statusObj.days[keyDay] || 0) + dayObj.status[statusId].count
                }
              }
            }
          }
        }

        // Attendants
        statusCategories.push(dashboard.attendant.name)
      }

      // todos os dias da semana
      weekCategories = Object.keys(weekDayKeys).sort()

      // Series Users
      let filteredAttendants = []
      for (let key of Object.keys(statusCount)) {
        // Status chart
        if (key !== 'CAMPANHA') {
          const statusGroupSeries = { name: key, data: [] }
          for (let attendant of statusCategories) {
            if (statusCount[key].attendants[attendant]) {
              if (statusCount[key].attendants[attendant] > 0) {
                statusGroupSeries.data.push(statusCount[key].attendants[attendant])
                if (!filteredAttendants.includes(attendant)) {
                  filteredAttendants.push(attendant)
                }
              }
            }
          }
          statusSeries.push(statusGroupSeries)
        }
        // Week chart
        const weekGroupSeries = { name: key, data: [] }
        for (let day of weekCategories) {
          if (statusCount[key].days[day]) {
            if (key !== 'CAMPANHA') {
              if (statusCount[key].days[day] < 0 && key === 'NOVO') {
                let keys = Object.keys(statusCount[key].days)
                let attendantStatusKey
                if (statusCount[key].attendants) {
                  attendantStatusKey = Object.keys(statusCount[key].attendants)
                } else {
                  attendantStatusKey = []
                }
                let count = 0
                for (let index = 0; index < attendantStatusKey.length; index++) {
                  let status = statusCount[key]
                  count = count + status.attendants[attendantStatusKey[index]]
                }
                let indexOfDay = keys.indexOf(day)
                indexOfDay = indexOfDay + 1
                for (let index = indexOfDay; index < keys.length; index++) {
                  count = count + (statusCount[key].days[keys[index]] - count)
                }
                weekGroupSeries.data.push(count)
              } else if (statusCount[key].days[day]) {
                if (statusCount[key].days[day] > 0) {
                  weekGroupSeries.data.push(statusCount[key].days[day])
                } else {
                  weekGroupSeries.data.push(null)
                }
              } else {
                weekGroupSeries.data.push(null)
              }
            }
          }
        }
        if (weekGroupSeries.data.length > 0) {
          weekSeries.push(weekGroupSeries)
        }
      }
      statusCategories = filteredAttendants
      this.customerCount = customerCount
      this.callCount = callCount
      this.paidCount = paidCount
      this.paidTotal = paidTotal
      this.statusCount = statusCount
      if (statusCount.NOVO) {
        this.customerNewstatusCount = statusCount.NOVO.count
      }
      if (this.statusCount['CAMPANHA']) {
        delete this.statusCount['CAMPANHA']
      }
      // updateStatusChart
      const labels = Object.keys(this.statusCount)
      this.chartStatusOptions.labels.length = 0
      this.chartStatusOptions.labels.push.apply(this.chartStatusOptions.labels, labels)
      this.chartStatusSeries = Object.values(this.statusCount).map(item => item.count)
      // updateUsersChart
      this.chartUsersSeries = statusSeries
      this.chartUsersOptions.xaxis.categories.length = 0
      this.chartUsersOptions.xaxis.categories.push.apply(this.chartUsersOptions.xaxis.categories, statusCategories)

      // updateWeekChart
      this.chartWeekSeries = weekSeries
      this.chartWeekOptions.xaxis.categories.length = 0
      const weekCategoriesFormated = weekCategories.map(key => moment(key).format('DD/MMM'))
      this.chartWeekOptions.xaxis.categories.push.apply(this.chartWeekOptions.xaxis.categories, weekCategoriesFormated)
    },
    loadDashboard() {
      let week = this.weekDateRef.format('YYYYww')
      let col = db.collection('dashboards').where('week', '==', week)

      const company = this.user.companyId
      const branch = this.user.branchId

      // filtros pelo profile
      if (this.user.profile === 'attendant') {
        col = col.where('attendant.id', '==', this.user.uid)
      } else if (this.user.profile === 'manager') {
        col = col.where('company.id', '==', company)
      } else if (this.user.profile === 'supervisor') {
        col = col.where('branch.id', '==', branch)
      }

      col.onSnapshot(payload => {
        if (payload.empty) this.dashboards = []
        else {
          this.dashboards = payload.docs.map(item =>
            firestoreUtils.docToObject(item)
          )
        }
        this.updateDashboard()
      })
    },
    loadCalls() {
      const company = this.user.companyId
      let col = db.collection('calls').limit(20)

      if (this.profile === 'attendant') {
        col = col.where('user.id', '==', this.user.uid)
      } else if (this.profile === 'supervisor') {
        col = col.where('branch.id', '==', this.user.branchId)
      } else if (this.profile === 'manager') {
        col = col.where('company.id', '==', company)
      }

      col.orderBy('createdAt', 'desc')
        .onSnapshot(payload => {
          if (payload.empty) this.calls = []
          else {
            this.calls = payload.docs.map(item =>
              firestoreUtils.docToObject(item)
            )
          }
        })
    },
    goToCustomer(id) {
      this.$router.push(`/customer/${id}`)
    }
  }
}
</script>

<style lang='stylus' scoped>
  .dashchart {
    margin-top -30px;
  }
</style>
